export default __webpack_public_path__ + "static/media/fast-food.6e854e73.svg";